<template>
  <div class="activity-box">
    <div class="main">
      <img class="bg" src="./images/bg.png" alt="" />
      <img
        src="https://resource.3uplay.com/sys-feed/7719c69c.webp"
        alt=""
        class="dressup1"
      />
      <img
        src="https://resource.3uplay.com/sys-feed/e4158a20.webp"
        alt=""
        class="dressup2"
      />
      <div class="tab-box" :class="{ active2: activeIndex === 2 }">
        <div class="tab" @click="checkScoreList(1)"></div>
        <div class="tab2" @click="checkScoreList(2)"></div>
        <img src="./images/tab1.png" alt="" v-show="activeIndex === 1" />
        <img src="./images/tab2.png" alt="" v-show="activeIndex === 2" />
      </div>
      <div class="week-score">{{ isPlayer ? weekScore : '---' }}</div>
      <div class="all-score">{{ isPlayer ? totalScore : '---' }}</div>
      <div class="top3-box" v-show="activeIndex === 2">
        <div
          v-for="(item, index) of topList.slice(0, 3)"
          :key="item.user_uuid"
          class="item"
          :class="`top${index + 1}`"
          @click="toPlayerDetail(item.user_uuid)"
        >
          <img :src="item.avatar_url" class="head-portrait" />
          <div class="user-name">{{ item.user_nickname }}</div>
          <div class="score">{{ item.jifen }}</div>
        </div>
      </div>
      <div class="score-board-box" v-show="activeIndex === 2">
        <div
          class="item"
          v-for="(item, index) of list.slice(3, 10)"
          :key="item.user_uuid"
          @click="toPlayerDetail(item.user_uuid)"
        >
          <div class="left">
            <span class="index">{{ index + 4 }}</span>
            <img :src="item.avatar_url" alt="排名頭像" class="" />
            <span class="user-name">{{ item.user_nickname }}</span>
          </div>
          <div class="right">
            <span class="scroe">{{ item.jifen || '--' }}積分</span>
          </div>
        </div>
      </div>
      <div class="top3-box" v-show="activeIndex === 1">
        <div
          v-for="(item, index) of topWeekList.slice(0, 3)"
          :key="item.user_uuid"
          class="item"
          :class="`top${index + 1}`"
          @click="toPlayerDetail(item.user_uuid)"
        >
          <img :src="item.avatar_url" class="head-portrait" />
          <div class="user-name">{{ item.user_nickname }}</div>
          <div class="score">{{ item.jifen }}</div>
        </div>
      </div>
      <div class="score-board-box" v-show="activeIndex === 1">
        <div
          class="item"
          v-for="(item, i) of weekList.slice(3, 10)"
          :key="item.user_uuid"
          @click="toPlayerDetail(item.user_uuid)"
        >
          <div class="left">
            <span class="index">{{ i + 4 }}</span>
            <img :src="item.avatar_url" alt="排名頭像" class="" />
            <span class="user-name">{{ item.user_nickname }}</span>
          </div>
          <div class="right">
            <span class="scroe">{{ item.jifen || '--' }}積分</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ActivityBox',
  data() {
    return {
      list: [],
      weekList: [],
      myScore: 0,
      activeIndex: 1,
      totalScore: 0,
      weekScore: 0
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
    // 是B端用户
    isPlayer() {
      return this.userInfo && this.userInfo.userKind === 'Player';
    },
    uuid() {
      return this.userInfo ? this.userInfo.uuid : '';
    },
    topList() {
      return this.list && this.list.length
        ? [this.list[1], this.list[0], this.list[2]]
        : [];
    },
    topWeekList() {
      return this.weekList && this.weekList.length
        ? [this.weekList[1], this.weekList[0], this.weekList[2]]
        : [];
    }
  },
  watch: {
    uuid: {
      handler: function(val) {
        if (val) {
          this.getMyscore(val);
        } else {
          this.myScore = 0;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getAllList() {
      try {
        const url = 'https://devops.nicee.app/api/jifen/shiwu/all/rank';
        const { data } = await this.$http.get(url);
        this.list = data || [];
      } catch (error) {
        console.log(error);
      }
    },
    async getWeekList() {
      try {
        const url =
          'https://devops.nicee.app/api/jifen/shiwu/week/rank';
        const { data } = await this.$http.get(url);
        this.weekList = data || [];
      } catch (error) {
        console.log(error);
      }
    },
    async getMyscore(uuid) {
      try {
        const url = `https://devops.nicee.app/api/jifen/shiwu/rank/${uuid}`;
        const { data } = await this.$http.get(url);
        if (data) {
          this.totalScore = data.jifen_total || 0;
          this.weekScore = data.jifen_week || 0;
        }
      } catch (error) {
        console.log(error);
      }
    },
    toPlayerDetail(userUuid) {
      this.$router.push({
        path: `/player-detail/${userUuid}`
      });
    },
    checkScoreList(index) {
      this.activeIndex = index;
    }
  },
  created() {
    this.getWeekList();
    this.getAllList();
  }
};
</script>
<style lang="scss" scoped>
.activity-box {
  width: 100%;
  background-color: #fff7e8;
  overflow: auto;
  text-align: center;
  background-image: url('./images/web-bg.png');
  background-size: 100% 100%;
  .main {
    position: relative;
    display: inline-block;
    width: 750px;
    text-align: left;
    > .bg {
      width: 100%;
    }
    .dressup1,
    .dressup2 {
      position: absolute;
      width: 194px;
      height: auto;
      top: 2012px;
    }
    .dressup1 {
      left: 116px;
    }
    .dressup2 {
      left: 450px;
    }
    .tab-box {
      position: absolute;
      top: 4251px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      font-size: 0;
      display: flex;
      img {
        width: auto;
        height: 142px;
        max-height: 100%;
        position: absolute;
        z-index: -1;
      }
      .tab,
      .tab2 {
        width: 272px;
        height: 142px;
        background-color: inherit;
      }
    }
    .week-score,
    .all-score {
      position: absolute;
      color: #0e6cef;
      font-size: 56px;
      font-weight: 400;
      height: 128px;
      line-height: 128px;
      z-index: 2;
      text-align: center;
      width: 300px;
      text-align: center;
      top: 4496px;
    }
    .week-score {
      left: 56px;
    }
    .all-score {
      right: 54px;
    }
    .top3-box {
      position: absolute;
      top: 4758px;
      display: flex;
      left: 52px;
      justify-content: space-around;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        // justify-content: center;
        font-size: 24px;
        flex: none;
        color: #0e6cef;
        width: dPx(97);
        margin: 0 10px;
        img {
          border-radius: 50%;
          object-fit: cover;
          width: 150px;
          height: 150px;
          // border: 3px white solid;
        }
        .user-name,
        .score {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          width: 100%;
          text-align: center;
          opacity: 0.9;
          font-weight: 400;
        }
        .user-name {
          margin-top: 30px;
          color: #0e6cef;
          font-weight: bold;
        }
        .score {
          margin-top: dPx(5);
          font-size: 24px;
          opacity: 0.9;
          font-weight: 400;
        }
        &.top1 {
          margin-left: 10px;
          margin-right: 14px;
        }
        &.top2 {
          margin-right: 13px;
        }
        &.top1,
        &.top3 {
          margin-top: 170px;
          img {
            height: 133px;
            width: 133px;
          }
        }
        &.top3 {
          .user-name {
            margin-top: 26px;
          }
        }
      }
    }
    .score-board-box {
      position: absolute;
      top: 5181px;
      left: 48px;
      // transform: translateX(-50%);
      width: 640px;
      overflow: auto;
      -ms-overflow-style: none; /* IE and Edge */
      scrollbar-width: none; /* Firefox */
      &::-webkit-scrollbar {
        display: none;
      }
      .item {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        width: 100%;
        height: 100px;
        font-size: 28px;
        margin-bottom: 7px;
        color: #0e6cef;
        border-radius: 40px;
        padding: 0;
        .score {
          opacity: 0.9;
          font-weight: 400;
        }
        .left,
        .right {
          display: flex;
          align-items: center;
        }
        .right {
          margin-left: 30px;
        }
        .left {
          .index {
            margin-left: dPx(24);
            margin-right: dPx(30);
            width: 30px;
            text-align: right;
          }
          img {
            width: 72px;
            height: 72px;
            border-radius: 50%;
            margin-right: dPx(26);
            object-fit: cover;
            border: 4px solid #adf5ee;
          }
          .user-name {
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
            width: 174px;
            color: #0e6cef;
            font-weight: bold;
          }
        }
        .right {
          img {
            width: 36px;
            margin: 0 0 0 14px;
          }
        }
      }
    }
  }
}
</style>
